<template>
  <div style="height: 87vh; overflow:auto">
    <div>
      <div>
        <div class="d-flex list-header">
          <div class="d-flex flex-column" style="width: 100%">
            <v-select v-model="selectedDate" :items="deliveryDates" @change="getOrderItems" label="集荷日" />
            <v-select
              v-if="isAdmin"
              v-model="selectedShippingArea"
              :items="shippingDrivers"
              item-value="id"
              item-text="name"
              @change="getOrderItems"
              class="mt-4"
              label="集荷エリア"
            />
            <v-select
              v-if="isAdmin"
              v-model="selectedDeliveryArea"
              :items="deliveryDrivers"
              item-value="id"
              item-text="name"
              @change="getOrderItems"
              class="mt-4"
              label="配送エリア"
            />
          </div>
        </div>

        <v-alert v-model="alert" color="blue" text dismissible class="ma-3">ステータスの変更が完了しました。</v-alert>
      </div>

      <v-container class="driver">
        <div>
          <div class="d-flex align-center justify-end">
            <span @click="changeView('list')">
              <list-icon style="width: 44px" :color="deliveryView ? '#111' : '#BDBDBD'" />
            </span>
            <span @click="changeView('grid')">
              <table-view :size="'44px'" :color="deliveryView ? '#BDBDBD' : '#111'" />
            </span>
          </div>
          <list-by-place :from="from" :to="to" :isAdmin="isAdmin" :viewType="deliveryView ? 'list' : 'card'"/>
        </div>
      </v-container>

      <div v-if="isConfirm" class="confirm-area">
        <v-btn class="flex-grow-1 mx-2" color="#00796B" outlined @click="clearSelected">選択全解除</v-btn>
        <v-btn
          class="flex-grow-1 mx-2 white--text"
          color="#00796B"
          depressed
          @click="openModal"
        >確認へ進む</v-btn>
      </div>
    </div>

    <v-dialog v-model="dialog" persistent max-width="600px" class="confirm-dialog">
      <v-card class="pb-3">
        <v-card-title class="d-flex justify-space-between">
          <span class="headline font-weight-bold">{{ listType == "from" ? "集荷" : "配送" }}確認</span>
          <v-btn text style="font-size: x-large;" @click="dialog = false">×</v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row v-for="(item, key) in detailItems" :key="key">
              <v-col cols="12 px-0">
                <div
                  class="p-4 d-flex align-center confirm-card"
                  :class="[listType === 'from' ? 'border-green' : 'border-orange']"
                >
                  <img :src="item.flower_image" width="100px;" height="150px;" style="object-fit: cover" class="mr-2" />
                  <div class="d-flex flex-column mr-auto">
                    <div class="d-flex flex-column mr-auto">
                      <p class="my-1">{{ item.flower_type }}</p>
                      <p class="order-item">{{ item.item_name }}</p>
                    </div>
                    <div class="d-flex flex-column mr-auto">
                      <div class="d-flex flex-row mr-auto block">
                      <div class="font-weight-bold mr-2">
                        <span class="small-gray">注文番号：</span>
                          {{ item.id }}
                      </div>
                      <div class="font-weight-bold mr-2">
                        <span class="small-gray">本数：</span>
                          {{ item.count }}
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-row mr-auto block">
                    <div class="font-weight-bold mr-2">
                      <span class="small-gray">全長</span>
                        {{ item.flower_harvest.stem_size_min }} 〜 {{ item.flower_harvest.stem_size_max }}cm
                    </div>
                  </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions v-if="hasUnconfirmedOrder" class="d-flex justify-center justify-space-between px-6">
          <div v-if="listType == 'from'" class="d-flex flex-column">
            <p class="red--text">未確定の注文が含まれていますが集荷完了にしますか？</p>
            <v-checkbox :label="'集荷完了にする'" :input-value="allowUnconfirmedOrderToShipped" @change="toggleFlag" color="success" class="mt-0"/>
          </div>
          <div v-else class="d-flex flex-column">
            <p class="red--text">未確定の注文は配送完了にできません</p>
          </div>
        </v-card-actions>
        <v-card-actions v-if="canEditStatus" class="d-flex justify-center justify-space-between px-6">
          <v-btn
            :color="listType == 'from' ? '#00796B' : '#FF6F00'"
            class="white--text"
            depressed
            @click="editStatus"
          >{{ listType == "from" ? "集荷" : "配送" }}完了にする</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ListIcon from "@/components/icons/ListIcon.vue";
import TableView from "@/components/icons/TableView.vue";
import ListByPlace from "@/components/driver/information/ListByPlace.vue";
import { formatDate } from "@/plugins/i18n";

export default {
  components: {
    ListIcon,
    TableView,
    ListByPlace,
  },
  data() {
    return {
      selectedDate: "",
      selectedShippingArea: 0,
      selectedDeliveryArea: 0,
      deliveryDates: [],
      deliveryView: true,
      detailItems: [],
      dialog: false,
      listType: "",
      alert: false,
      allowUnconfirmedOrderToShipped: false,
      canEditStatus: false
    };
  },
  async created() {
    await this.$store.dispatch("drivers/getAreas");
    await this.$store.dispatch("drivers/getDrivers");
    await this.getOrderItems();
    await this.initializeDeliveryDate();
  },
  computed: {
    areas() {
      const areas = [...this.$store.state.drivers.areas];
      areas.unshift({ id: 0, name: "全エリア", note: "" });
      return areas;
    },
    shippingDrivers() {
      let drivers = [...this.$store.state.drivers.drivers];
      drivers = drivers.filter(d => d.driver_type === "shipping");
      drivers.unshift({ id: 0, name: "全エリア", note: "" });
      return drivers;
    },
    deliveryDrivers() {
      let drivers = [...this.$store.state.drivers.drivers];
      drivers = drivers.filter(d => d.driver_type === "delivery");
      drivers.unshift({ id: 0, name: "全エリア", note: "" });
      return drivers;
    },
    from() {
      const from = [...this.$store.state.driverInformation.from];
      if (this.selectedShippingArea === 0) {
        return from;
      }
      return from.filter(f => f.area_id === this.selectedShippingArea);
    },
    to() {
      const to = [...this.$store.state.driverInformation.to];
      if (this.selectedDeliveryArea === 0) {
        return to;
      }
      return to.filter(t => t.area_id === this.selectedDeliveryArea);
    },
    orders() {
      return this.$store.state.driverInformation.orders;
    },
    ordersByFarm() {
      return this.$store.state.driverInformation.ordersByFarm;
    },
    ordersByShop() {
      return this.$store.state.driverInformation.ordersByShop;
    },
    selectedList() {
      return this.$store.state.driverInformation.selectedList;
    },
    isConfirm() {
      return (
        this.selectedList.delivery.from.length > 0
        || this.selectedList.delivery.to.length > 0
      );
    },
    driverType() {
      return this.$store.state.user.driver && this.$store.state.user.driver.driver_type;
    },
    isDelivereyDriver() {
      return this.driverType === "delivery";
    },
    isShippingDriver() {
      return this.driverType === "shipping";
    },
    isAdmin() {
      return (
        this.$store.state.user.driver && this.$store.state.user.driver.is_admin
      );
    },
    hasUnconfirmedOrder() {
      return this.detailItems.some(item => item.status === "unconfirmed");
    },
    availableDateList() {
      return this.$store.state.driverInformation.availableDateList.map(date => this.formatDate(date));
    }
  },
  methods: {
    changeView(type) {
      this.deliveryView = type === "list";
      this.clearSelected();
    },
    initializeDeliveryDate() {
      this.selectedDate = this.availableDateList[0];
    },
    getAreaIds(driver) {
      if (driver.id !== 0) {
        return driver.areas.map(d => d.id);
      }
      return null;
    },
    getOrderItems() {
      const shippingDriver = this.shippingDrivers.find(driver => driver.id === this.selectedShippingArea);
      const deliveryDriver = this.deliveryDrivers.find(driver => driver.id === this.selectedDeliveryArea);
      const shippingAreaIds = this.getAreaIds(shippingDriver);
      const deliveryAreaIds = this.getAreaIds(deliveryDriver);
      this.$store.dispatch("driverInformation/getOrderItems", {
        dateFrom: this.selectedDate,
        dateTo: this.selectedDate,
        shippingAreaIds,
        deliveryAreaIds
      }).then(() => {
        this.deliveryDates = this.availableDateList;
      });
    },
    formatDate(d) {
      return formatDate(d, "yyyy-mm-dd");
    },
    clearSelected() {
      this.$store.dispatch("driverInformation/clearSelected");
    },
    openModal() {
      this.listType = this.selectedList.delivery.from.length > 0 ? "from" : "to";
      this.detailItems = this.selectedList.delivery.from.length > 0
        ? this.selectedList.delivery.from
        : this.selectedList.delivery.to;

      if (this.validItems(this.detailItems)) {
        this.dialog = true;
        this.allowUnconfirmedOrderToShipped = !this.hasUnconfirmedOrder;
        this.canEditStatus = !this.hasUnconfirmedOrder;
      } else {
        this.$store.dispatch("setSnackBar", { msg: "変更できないステータスの注文が含まれています。選択を解除してください。", color: "red" }, { root: true });
        this.$store.dispatch("snackOn", {}, { root: true });
      }
    },
    validItems(items) {
      let arrowStatus = [];
      if (this.isShippingDriver) {
        if (this.listType === "from") {
          arrowStatus = ["unconfirmed", "confirmed", "packed"];
        } else {
          arrowStatus = ["shipped"];
        }
      } else if (this.isDelivereyDriver) {
        if (this.listType === "from") {
          arrowStatus = ["unloaded", "unconfirmed", "confirmed", "packed"];
        } else {
          arrowStatus = ["picked", "shipped"];
        }
      } else {
        return true;
      }

      const invalidItems = items.filter(item => !arrowStatus.includes(item.status));

      return invalidItems.length === 0;
    },
    async editStatus() {
      let itemType = "from";
      const items = this.detailItems.reduce((ids, item) => {
        if (item.type === "to") itemType = "to";
        if (!(item.type === "from" && item.status === "shipped")) {
          ids.push(item.id);
        }
        return ids;
      }, []);

      await this.$store.dispatch("driverInformation/editStatus", {
        transitionType: !this.isDelivereyDriver && itemType === "from" ? "shipped" : "forward",
        items,
      });

      this.getOrderItems();
      this.dialog = false;
      this.alert = true;
    },
    toggleFlag() {
      this.allowUnconfirmedOrderToShipped = !this.allowUnconfirmedOrderToShipped;
      this.canEditStatus = this.allowUnconfirmedOrderToShipped;
    }
  },
};
</script>

<style scoped>
.list-header {
  padding: 12px;
  background-color: #ffffff;
}
.confirm-area {
  position: fixed;
  width: 100%;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  margin: 24px 0;
}
.confirm-card {
  padding: 10px;
  border-style: solid;
  border-radius: 5px;
  border-width: 2px;
}
.border-green {
  border-color: #00796b;
}
.border-orange {
  border-color: #ff6f00;
}
.confirm-card .order-item {
  font-size: 20px;
  font-weight: bold;
}
.small-gray {
  font-size: 12px;
  color: #bdbdbd;
}
.flower_image {
  object-fit: cover;
}
</style>
